import { render } from "./ServerWillBeOffNotification.vue?vue&type=template&id=a16e57ca"
import script from "./ServerWillBeOffNotification.vue?vue&type=script&lang=js"
export * from "./ServerWillBeOffNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__